// extracted by mini-css-extract-plugin
export default {"postsPage":"postsPage_OAyxN","posts":"posts_FPdFh"};